/**
 * @typedef {Object} BookingLocationViewModelType
 * @property {number} id - Unique identifier
 * @property {string} name - The name of the location
 * @property {string} timeZone - The location's time zone
 *

/**
 * @class
 */
export default class BookingLocationViewModel {
  /**
   * Create a new BookingLocationViewModel.
   * @param {...BookingLocationViewModelType} params
   */
  constructor(params) {
    this.id = params.id
    this.name = params.name
    this.timeZone = params.timeZone
  }
}
